import React, { useState, useEffect } from 'react';
import Select from "react-select";
import axios from 'axios';
import './ActiveLocations.css';
import { baseURL } from './backend_url';
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from "sweetalert2";
import '@fortawesome/fontawesome-free/css/all.min.css';


function ActiveLocations() {
  const [companyDetail, setCompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("Routes Car Rental");
  const [companyId, setCompanyId] = useState("690337");
  const [locationDetail, setLocationDetail] = useState([]);
  const [locationName, setLocationName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [airportName, setAirportName] = useState("");
  const [terminal, setTerminal] = useState("");
  const [pillars, setPillars] = useState([]);
  const [savedData, setSavedData] = useState([]);
  const [hashLocationNameVsID, setHashLocationNameVsID] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // "add" or "edit"
  const [editIndex, setEditIndex] = useState(null);
  const [viewMapFlag, setViewMapFlag] = useState(false); // State to control map view
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [policyData, setPolicyData] = useState({
    validDriversLicense: "",
    paymentMethods: "",
    deposit: "",
    localRenters: ""
  });
  const [savedPolicies, setSavedPolicies] = useState([]);
  const [policyEditIndex, setPolicyEditIndex] = useState(null);
  const [access, setAccess] = useState("Edit");

  useEffect(() => {
    const companyIdTemp = '690337'
    setCompanyId(companyIdTemp);
    setSavedData([])
    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);
    if ('Users' === foundUser.role) {

      setAccess(foundUser.access['DesignatedPickUpPoints_Access Specifier'])
    }

    axios.get(baseURL + "/get_company_location/" + companyIdTemp)
      .then((res) => {
        axios.get(baseURL + "/srt_get_active_location/" + companyIdTemp.toString())
          .then((res1) => {
            axios.get(baseURL + "/srt_get_user_location/" + foundUser.userEmail)
              .then((res2) => {
                const assigned_location_hash = res2.data;
                let allTemp = res.data.res;
                let hashLocationNameId = {};
                allTemp.forEach((k) => hashLocationNameId[k.location_id] = k.location_name);
                setHashLocationNameVsID(hashLocationNameId);
                if (allTemp.length > 0) {
                  let tempArr = [];
                  for (let i = 0; i < allTemp.length; i++) {
                    if (foundUser.role === 'Users') {
                      if (res1.data[allTemp[i].location_id] === true && assigned_location_hash[allTemp[i].location_id] === true) {
                        tempArr.push(allTemp[i]);
                      }
                    }
                    else {
                      if (res1.data[allTemp[i].location_id] === true) {
                        tempArr.push(allTemp[i]);
                      }
                    }
                  }
                  setLocationDetail(tempArr);
                }
              })
          })
      });
  }, []);

  const handleInputChangeCompanyName = (selectedOption) => {
    setCompanyName(selectedOption.value);
  };

  const handleInputChangeLocationName = (selectedOption) => {
    setLocationName(hashLocationNameVsID[selectedOption.value]);
    setAirportName(hashLocationNameVsID[selectedOption.value]);
    const locationId = selectedOption.value;
    setLocationId(locationId);

    axios.get(`${baseURL}/srt_get_terminal_data/${locationId}`)
      .then((response) => {
        const terminalData = response.data.terminals || [];
        setSavedData(terminalData);
      })
      .catch((error) => {
        console.error("Error fetching terminal data:", error);
        setSavedData([]);  // Clear savedData in case of error
      });

    axios.get(`${baseURL}/srt_get_policy_data/${locationId}`)
      .then((response) => {
        const policyData = response.data.policies || [];
        setSavedPolicies(policyData);
      })
      .catch((error) => {
        console.error("Error fetching policy data:", error);
        setSavedPolicies([]);  // Clear savedPolicies in case of error
      });
  };

  const handleAddPolicy = () => {
    setShowPolicyModal(true);
    setPolicyEditIndex(null);
    setPolicyData({
      validDriversLicense: "",
      paymentMethods: "",
      deposit: "",
      localRenters: ""
    });
  };

  const handleEditPolicy = (index) => {
    setShowPolicyModal(true);
    setPolicyEditIndex(index);
    setPolicyData(savedPolicies[index].policyData);
  };

  const handleSavePolicy = () => {
    const newPolicyData = { ...policyData };
    if (policyEditIndex !== null) {
      const updatedPolicies = [...savedPolicies];
      updatedPolicies[policyEditIndex] = { policyData: newPolicyData };
      setSavedPolicies(updatedPolicies);
      axios.put(`${baseURL}/srt_update_policy_data`, { locationId, newPolicyData, index: policyEditIndex })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.error("Error updating policy data:", error);
        });
    } else {
      setSavedPolicies([...savedPolicies, { policyData: newPolicyData }]);
      axios.post(`${baseURL}/srt_save_policy_data`, { locationId, newPolicyData })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.error("Error saving policy data:", error);
        });
    }
    setShowPolicyModal(false);
  };

  const handleClosePolicyModal = () => {
    setShowPolicyModal(false);
  };

  const handleAddTerminal = () => {
    setModalType("add");
    setTerminal("");
    setPillars([]);
    setShowModal(true);
  };

  const handleEdit = (index) => {
    const dataToEdit = savedData[index];
    setModalType("edit");
    setEditIndex(index);
    setAirportName(dataToEdit.airportName);
    setTerminal(dataToEdit.terminal);
    setPillars(dataToEdit.pillars);
    setShowModal(true);
  };

  // const handleSave = () => {
  //   const newData = { airportName, terminal, pillars };
  //   if (modalType === "add") {
  //     setSavedData([...savedData, newData]);
  //     axios.post(`${baseURL}/srt_save_terminal_data`, { locationId, newData })
  //       .then((response) => {
  //         console.log(response.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error saving terminal data:", error);
  //       });
  //   } else if (modalType === "edit") {
  //     const updatedData = [...savedData];
  //     updatedData[editIndex] = newData;
  //     setSavedData(updatedData);
  //     axios.put(`${baseURL}/srt_update_terminal_data`, { locationId, newData, index: editIndex })
  //       .then((response) => {
  //         console.log(response.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error updating terminal data:", error);
  //       });
  //   }
  //   setShowModal(false);
  // };

  const handleSave = () => {
    const newData = { airportName, terminal, pillars };
    const formData = new FormData(); // Create a FormData object

    // Append terminal data to FormData
    formData.append('locationId', locationId);
    formData.append('airportName', airportName);
    formData.append('terminal', terminal);
    formData.append('pillars', JSON.stringify(pillars)); // Convert pillars to JSON string

    // Append image data for each pillar
    pillars.forEach((pillar, index) => {
      if (pillar.image) {
        formData.append(`image_${index}`, pillar.image); // Append image with a unique key
      }
    });

    if (modalType === "add") {
      setSavedData([...savedData, newData]);
      axios.post(`${baseURL}/srt_save_terminal_data`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // Set the content type for FormData
        }
      })
        .then((response) => {
          if(response.data.message === 'success'){
            Swal.fire({
              position: 'middle',
              icon: 'success',
              title: 'Saved Successfully !!',
              showConfirmButton: false,
              timer: 3000
            })
          }
          else{
            Swal.fire({
              position: 'middle',
              icon: 'error',
              title: 'Failed to save',
              showConfirmButton: false,
              timer: 3000
            })
          }
        })
        .catch((error) => {
          console.error("Error saving terminal data:", error);
        });
    } else if (modalType === "edit") {
      const updatedData = [...savedData];
      updatedData[editIndex] = newData;
      setSavedData(updatedData);
      axios.put(`${baseURL}/srt_update_terminal_data/${editIndex}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // Set the content type for FormData
        }
      })
        .then((response) => {
          if(response.data.message === 'success'){
          Swal.fire({
            position: 'middle',
            icon: 'success',
            title: 'Updated Successfully !!',
            showConfirmButton: false,
            timer: 3000
          })
        }
        else{
          Swal.fire({
            position: 'middle',
            icon: 'error',
            title: 'Failed to update',
            showConfirmButton: false,
            timer: 3000
          })
        }
        })
        .catch((error) => {
          console.error("Error updating terminal data:", error);
        });
    }
    setShowModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleAddPillar = () => {
    setPillars([...pillars, { number: "", latitude: "", longitude: "", arrivalInstruction: "" }]);
  };

  const handleRemovePillar = (index) => {
    const updatedPillars = pillars.filter((_, i) => i !== index);
    setPillars(updatedPillars);
  };

  const handlePillarChange = (index, field, value) => {
    const updatedPillars = [...pillars];
    updatedPillars[index][field] = value;
    setPillars(updatedPillars);
  };

  const getLineCharacterCounts = (text) => {
    return text.split('\n').map(line => line.length);
  };

  const lineCountsvalidDriversLicense = getLineCharacterCounts(policyData.validDriversLicense);
  const lineCountspaymentMethods = getLineCharacterCounts(policyData.paymentMethods);
  const lineCountsdeposit = getLineCharacterCounts(policyData.deposit);
  const lineCountslocalRenters = getLineCharacterCounts(policyData.localRenters);


  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const updatedPillars = [...pillars];
        updatedPillars[index].image = reader.result; // Now index is defined
        setPillars(updatedPillars);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = (index) => {
    const updatedPillars = [...pillars];
    delete updatedPillars[index].image; // Remove the image from the specific pillar
    setPillars(updatedPillars); // Update the state with the modified pillars
  };

  return (
    <div className="container mt-2" >
      <div className="p-5 bg-light rounded shadow-sm" >
        <h4 className="text-primary mb-4">Designated PickUp Points</h4>
        {/* Company name selection here... */}
        {companyName && (
          <>
            <div className="mb-4">
              <label htmlFor="location_name" className="form-label">
                Select Location
              </label>
              <Select
                value={{ value: locationName, label: (locationName ? locationName : "Select Location Name") }}
                inputId="location_name"
                name="location_name"
                options={locationDetail.map(location => ({
                  value: location.location_id,
                  label: `${location.location_name} - ${location.location_id.split('-')[1]}`
                }))}
                onChange={handleInputChangeLocationName}
              />
            </div>

            {locationName &&
              <>
                <div className='row mb-4'>
                  <div className='col-md-6'>
                    {access === 'Edit' &&
                      <Button className="mb-3" onClick={handleAddTerminal}>Add Terminal</Button>
                    }
                  </div>
                  <div className='col-md-6 d-flex justify-content-end'>
                    {access === 'Edit' &&
                      <Button className="mb-3 ml-3" disabled={savedPolicies.length > 0} onClick={handleAddPolicy}>Add Terms & Conditions</Button>
                    }
                  </div>
                </div>
                <table className="table ">
                  <thead>
                    <tr>
                      <th scope="col">Airport Name</th>
                      <th scope="col">Terminal</th>
                      <th scope="col">Pickup Point</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(savedData) && savedData.map((data, index) => (
                      <tr key={index}>
                        <td>{data.airportName}</td>
                        <td>{data.terminal}</td>
                        <td>
                          <table className="table table-sm table-borderless">
                            <thead>
                              <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Latitude</th>
                                <th scope="col">Longitude</th>
                                <th scope="col">Shuttle Instructions</th>
                                <th scope="col">PickUp Point Picture</th>
                              </tr>
                            </thead>
                            <tbody >
                              {data.pillars.map((pillar, pIndex) => (
                                <tr key={pIndex}>
                                  <td>{pillar.number}</td>
                                  <td>{pillar.latitude}</td>
                                  <td>{pillar.longitude}</td>
                                  <td><pre>{pillar.arrivalInstruction}</pre></td>
                                  <td>{pillar.image ? <img src={pillar.image} alt={`Pillar ${pillar.number}`} style={{
                                      width: "30%",
                                      height: "auto",
                                      cursor: "pointer",
                                      margin: "auto",
                                    }}
                                    onClick={(e) =>
                                      (e.target.style.width =
                                        e.target.style.width === "30%"
                                          ? "100%"
                                          : "30%")
                                    }/> : ''}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                        <td>
                          <Button variant="primary" size="sm" onClick={() => handleEdit(index)}>Edit</Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <h4 className="text-primary mt-4 mb-3">PickUp Terms & Conditions</h4>
                <span style={{color: 'red'}}>Note: This content is being sent to the Customer in the Shuttle Tracker Email.</span>
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Valid Driver's License</th>
                      <th scope="col">Payment Methods</th>
                      <th scope="col">Deposit</th>
                      <th scope="col">Local Renters</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(savedPolicies) && savedPolicies.map((policy, index) => (
                      <tr key={index}>
                        <td><pre>{policy.policyData.validDriversLicense}</pre></td>
                        <td><pre>{policy.policyData.paymentMethods}</pre></td>
                        <td><pre>{policy.policyData.deposit}</pre></td>
                        <td><pre>{policy.policyData.localRenters}</pre></td>
                        <td>
                          <Button variant="primary" size="sm" onClick={() => handleEditPolicy(index)}>Edit</Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </table>
              </>
            }
          </>
        )}
      </div>

      {/* React Bootstrap Modal for Terminal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{modalType === "add" ? "Add Terminal" : "Edit Terminal"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Terminal</Form.Label>
              <Form.Control
                type="text"
                value={terminal}
                onChange={(e) => setTerminal(e.target.value)}
              />
            </Form.Group>
            {pillars.map((pillar, index) => (
              <div key={index}>
                <h5>PickUp Point {index + 1}</h5>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={pillar.number}
                    onChange={(e) => handlePillarChange(index, 'number', e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Latitude</Form.Label>
                  <Form.Control
                    type="text"
                    value={pillar.latitude}
                    onChange={(e) => handlePillarChange(index, 'latitude', e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Longitude</Form.Label>
                  <Form.Control
                    type="text"
                    value={pillar.longitude}
                    onChange={(e) => handlePillarChange(index, 'longitude', e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Shuttle Instructions</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={pillar.arrivalInstruction}
                    onChange={(e) => handlePillarChange(index, 'arrivalInstruction', e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Upload Pickup Point Image &nbsp;</Form.Label>
                  
                  <label className="custom-file-upload p-2">
                    <input accept="image/*" type="file" onChange={(e) => handleImageChange(e, index)} placeholder="Choose image" />
                    {/* <i className="fa fa-cloud-upload"></i> */}
                  </label>
               
                  {pillar.image && (
                    <>
                      <img src={pillar.image} alt="Preview" style={{
                                          width: "50%",
                                          height: "auto",
                                          cursor: "pointer",
                                          margin: "auto",
                                        }}
                                        onClick={(e) =>
                                          (e.target.style.width =
                                            e.target.style.width === "50%"
                                              ? "100%"
                                              : "50%")
                                        } />
                     <i className="fa fa-trash ml-3" onClick={() => handleRemoveImage(index)} style={{ cursor: "pointer", margin: "0 10px" }}></i>
                    </>
                  )}
                </Form.Group>
                
                <Button variant="danger" onClick={() => handleRemovePillar(index)}>Remove PickUp Point</Button>
              </div>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
          <Button variant="primary" onClick={handleAddPillar}>Add Pickup Point</Button>
          <Button variant="success" onClick={handleSave}>Save changes</Button>
        </Modal.Footer>
      </Modal>

      {/* React Bootstrap Modal for Policy */}
      <Modal show={showPolicyModal} onHide={handleClosePolicyModal}>
        <Modal.Header closeButton>
          <Modal.Title>{policyEditIndex === null ? "Add Policy" : "Edit Policy"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span style={{ color: 'red' }}>Note: Please ensure no line exceeds 42 characters. Content will appear in the email image as shown.</span>
          <Form>
            <Form.Group className="mb-3 pt-3">
              <Form.Label>Valid Driver's License</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={policyData.validDriversLicense}
                onChange={(e) => setPolicyData({ ...policyData, validDriversLicense: e.target.value })}
              />
              {lineCountsvalidDriversLicense.map((count, index) => (
                <small style={{ margin: '5px' }} key={index}>Line {index + 1} Character Count: {count}</small>
              ))}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Payment Methods</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={policyData.paymentMethods}
                onChange={(e) => setPolicyData({ ...policyData, paymentMethods: e.target.value })}
              />
              {lineCountspaymentMethods.map((count, index) => (
                <small style={{ margin: '5px' }} key={index}>Line {index + 1} Character Count: {count}</small>
              ))}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Deposit</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={policyData.deposit}
                onChange={(e) => setPolicyData({ ...policyData, deposit: e.target.value })}
              />
              {lineCountsdeposit.map((count, index) => (
                <small style={{ margin: '5px' }} key={index}>Line {index + 1} Character Count: {count}</small>
              ))}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Local Renters</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={policyData.localRenters}
                onChange={(e) => setPolicyData({ ...policyData, localRenters: e.target.value })}
              />
              {lineCountslocalRenters.map((count, index) => (
                <small style={{ margin: '5px' }} key={index}>Line {index + 1} Character Count: {count}</small>
              ))}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePolicyModal}>Close</Button>
          <Button variant="success" onClick={handleSavePolicy}>Save changes</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ActiveLocations;
